import APIService from '@/services/APIService.js';

export default {
  getAllImportacoes() {
    return APIService.apiCall().get(`/importacoesSped/getAllImportacoes`);
  },

  salvar(postData) {
    return APIService.apiCall().post(`/importacoesSped/salvar`, JSON.stringify(postData));
  },

  apagarArquivo(file) {
    return APIService.apiCall().post(`/ImportacoesSpedFiles/deleteMappingFile`, JSON.stringify(file));
  },

  deletar(id) {
    return APIService.apiCall().get(`/importacoesSped/deletar/${id}`);
  },

  setUpdates(update) {
    return APIService.apiCall().post(`/importacoesSped/setUpdates`, JSON.stringify(update));
  },

  changeStatusAguardando(postData, id) {
    return APIService.apiCall().post(`/importacoesSped/changeStatusAguardando/${id}`, JSON.stringify(postData));
  },

  getFilesImportacao(id) {
    return APIService.apiCall().get(`/ImportacoesSpedFiles/getFilesImportacao/${id}`);
  },

  getImportacaoSpead(id) {
    return APIService.apiCall().get(`/importacoesSped/getImportacaoSpead/${id}`);
  },

  uploadFile(postData, onUploadProgress, id) {
    return APIService.apiCall().post(`ImportacoesSpedFiles/upload/${id}`, postData, {
      timeout: 60 * 60 * 1000,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  baixarFile(id, config = {}) {
    return APIService.apiCall().get(`/ImportacoesSpedFiles/baixarFile/${id}`, { responseType: 'blob', ...config });
  }
};
